import type { CheckReportStatusResponse } from '../model/check-report-status-response';

export interface ReportApi {
  checkReportStatus: (reportId: string) => Promise<CheckReportStatusResponse>;
  downloadReport: (reportId: string) => Promise<ArrayBuffer>;
}

export const REPORT_API_KEY = 'reportApi';
